// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-cash-action" class="box product-operation" ng-if="\$ctrl.termDeposit">

    <sub-header header="'Deposit termination with cash'"></sub-header>

    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.termDeposit.productDefinition.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.termDeposit.balance > 0, 'currency--negative': \$ctrl.termDeposit.balance < 0}">
          {{\$ctrl.termDeposit.balance | nxCurrency}}
        </span>
      </div>
      <div class="override">
        <span class="key">Override withdraw amount:</span>
        <span class="value"><input type="checkbox" ng-model="\$ctrl.overrideCheckbox"/></span>
      </div>
    </div>

  <h2 class="section-header">Please confirm the following:</h2>
    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <tr ng-if="\$ctrl.overrideCheckbox">
          <td></td>
          <td></td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Default
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Overridden
          </td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td></td>
          <td>Gross interest:</td>
          <td>
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.interest"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">

            <cash ng-disabled="true" ng-model="\$ctrl.override.grossInterest"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withholding tax:</td>
          <td>
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.withholdingTax"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.withholdingTax" ng-change="\$ctrl.recalculate()" min="0"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Net interest:</td>
          <td>
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.netInterest"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.netInterest" ng-change="\$ctrl.recalculate()" min="0"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Interest credited:</td>
          <td>
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.interestCredited"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.interestCredited"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withholding tax on interest credited:</td>
          <td>
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.appliedWithholdingTax"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-disabled="true" ng-model="\$ctrl.interestForecast.appliedWithholdingTax"></cash>
          </td>
        </tr>
        <tr ng-repeat="fee in \$ctrl.interestForecast.terminationFees">
          <td></td>
          <td>{{fee.name}}</td>
          <td>
            <cash ng-model="fee.amount" ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="fee.newAmount" ng-change="\$ctrl.terminationFeeChanged()"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withdraw amount:</td>
          <td>
            <cash ng-disabled="true" ignore-amount-validation="\$ctrl.overrideCheckbox" ng-model="\$ctrl.terminationAmount"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-disabled="true" ng-model="\$ctrl.override.amount"></cash>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <signature-card
          file-id="\$ctrl.termDeposit.signatureCardFileId"
          product-group="'DEPOSIT'"
          product-status="\$ctrl.termDeposit.status"></signature-card>
        <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button type="submit" class="btn btn-danger" ng-click="\$ctrl.terminate()"
                ng-disabled="!\$ctrl.terminationAmount || \$ctrl.transactionForm.\$invalid">
          Terminate
        </button>
      </div>
    </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/cash-termination/cash-termination.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;